export function fmtBRL(n){
  const v = Number(n)||0;
  return v.toLocaleString('pt-BR', { style:'currency', currency:'BRL' });
}
export function fmtNum(n){ return Number(n||0).toLocaleString('pt-BR'); }
export function fmtPct(n){ return (Number(n)||0).toLocaleString('pt-BR', {maximumFractionDigits:1}) + '%'; }
export function fmtDate(d){
  if(!d) return '—';
  const dt = new Date(d + 'T00:00:00');
  if(isNaN(dt)) return d;
  return dt.toLocaleDateString('pt-BR');
}

export function fmtCompact(v){
  if(Math.abs(v) >= 1000) return (v/1000).toLocaleString('pt-BR',{maximumFractionDigits:1})+'k';
  return v.toLocaleString('pt-BR',{maximumFractionDigits:0});
}

export function fmtCompactBRL(v){
  const sinal = v<0 ? '-' : '';
  const abs = Math.abs(v);
  if(abs >= 1000000) return `${sinal}R$ ${(abs/1000000).toLocaleString('pt-BR',{maximumFractionDigits:1})}M`;
  if(abs >= 1000) return `${sinal}R$ ${(abs/1000).toLocaleString('pt-BR',{maximumFractionDigits:1})}k`;
  return `${sinal}${fmtBRL(abs)}`;
}

export function fmtUSD(v){
  return (Number(v)||0).toLocaleString('en-US', { style:'currency', currency:'USD' });
}

export function fmtCompactUSD(v){
  const sinal = v<0 ? '-' : '';
  const abs = Math.abs(v);
  if(abs >= 1000000) return `${sinal}$${(abs/1000000).toLocaleString('en-US',{maximumFractionDigits:1})}M`;
  if(abs >= 1000) return `${sinal}$${(abs/1000).toLocaleString('en-US',{maximumFractionDigits:1})}k`;
  return `${sinal}${fmtUSD(abs)}`;
}

export function deltaPct(atual, anterior){
  if(!anterior) return atual > 0 ? null : 0;
  return ((atual - anterior) / anterior) * 100;
}
export function deltaClass(p){ return p === null || Math.abs(p) < 0.05 ? 'flat' : p > 0 ? 'up' : 'down'; }
export function fmtDelta(p){
  if(p === null) return 'novo';
  if(Math.abs(p) < 0.05) return '0,0%';
  const sinal = p > 0 ? '+' : '−';
  return sinal + Math.abs(p).toLocaleString('pt-BR', { minimumFractionDigits:1, maximumFractionDigits:1 }) + '%';
}
export function deltaMini(p){
  const cls = deltaClass(p);
  const seta = cls === 'up' ? '▲' : cls === 'down' ? '▼' : '•';
  return `<span class="delta-mini ${cls}">${seta} ${fmtDelta(p)}</span>`;
}
